import { render, staticRenderFns } from "./EndMatchConfirmModal.vue?vue&type=template&id=9865d24e&scoped=true"
import script from "./EndMatchConfirmModal.vue?vue&type=script&lang=js"
export * from "./EndMatchConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./EndMatchConfirmModal.vue?vue&type=style&index=0&id=9865d24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9865d24e",
  null
  
)

export default component.exports